export const SSO_RETURN_URL_PARAM = 'returnUrl'
export const CLIENT_RETURN_URL_PARAM = 'redirect'
export const CLIENT_PARAM = 'client'
export const REDIRECT_URL_PARAM = 'sr'
export const INTERNAL_REDIRECT = 'ir'
